import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import StoryHero from "./components/StoryHero";
import OriginSection from "./components/OriginSection";
import Philosophy from "./components/Philosophy";
import Timeline from "./components/Timeline";
import TeamSection from "./components/TeamSection";

export default function Story() {
  useSmoothScroll();

  return (
    <div className="min-h-screen bg-bone text-ink">
      <Navbar />
      <main>
        <StoryHero />
        <OriginSection />
        <Philosophy />
        <Timeline />
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
}